import {
  COMPANY_ORGANIZATION_FETCHING,
  COMPANY_ORGANIZATION_FAILED,
  COMPANY_ORGANIZATION_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case COMPANY_ORGANIZATION_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case COMPANY_ORGANIZATION_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case COMPANY_ORGANIZATION_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
